import { useEffect } from 'react'
import { NavigationService } from '../services'

export const useKeyboard = () => {
  useEffect(() => {
    const handleChatNavigation = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === 'n') {
        const chatId = prompt('Enter chat ID to navigate to:')
        if (chatId) {
          NavigationService.getInstance().navigate(`/chats/${chatId}`)
        }
      }
    }

    window.addEventListener('keydown', handleChatNavigation)
    return () => {
      window.removeEventListener('keydown', handleChatNavigation)
    }
  }, [])
}
